import React, { useContext, useState } from "react";
import styled from "styled-components";
import Stat from "./Stat";
import ActionAreas from "./ActionAreas";
import { GraphicsContext } from "../../contexts/GraphicsContext";
import { DataContext } from "../../contexts/DataContext";
import { UserContext } from "../../contexts/UserContext";

const Main = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-top: 20px;
  font-size: 0.8em;
`;
const Row = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  font-size: 1em;
  font-weight: 100;
  align-items: center;
`;
const Button = styled.div`
  padding: 0.5em;
  min-width: 50px;
  display: flex;
  background-color: ${(props) => (props.selected ? "#db0a41" : "#202731")};
  justify-content: center;
  align-items: center;
  height: 55%;
  border-radius: 4px;
  margin: 0.5em;
  box-sizing: border-box;
  :hover {
    background-color: #db0a41;
    cursor: pointer;
  }
`;
export default function SportecTeamStats({ game }) {
  const { user, teams: user_teams } = useContext(UserContext);
  return (
    <Main>
      <Row>
        <Stat
          game={game}
          category={"Shots"}
          stat={{
            home: game?.sportec_team_stats?.home?.find(
              (stat) => stat.type === "ShotsAtGoalSum",
            )?.value,
            away: game?.sportec_team_stats?.away?.find(
              (stat) => stat.type === "ShotsAtGoalSum",
            )?.value,
          }}
          secondary_category={"On Target"}
          secondary_stat={{
            home: game?.sportec_team_stats?.home?.find(
              (stat) => stat.type === "ShotsOnTarget",
            )?.value,
            away: game?.sportec_team_stats?.away?.find(
              (stat) => stat.type === "ShotsOnTarget",
            )?.value,
          }}
        />
      </Row>
      <Row>
        <Stat
          game={game}
          category={"On Target"}
          stat={{
            home: game?.sportec_team_stats?.home?.find(
              (stat) => stat.type === "ShotsOnTarget",
            )?.value,
            away: game?.sportec_team_stats?.away?.find(
              (stat) => stat.type === "ShotsOnTarget",
            )?.value,
          }}
        />
      </Row>

      <Row>
        <Stat
          game={game}
          category={"Corners"}
          stat={{
            home: game?.sportec_team_stats?.home?.find(
              (stat) => stat.type === "CornerKicksSum",
            )?.value,
            away: game?.sportec_team_stats?.away?.find(
              (stat) => stat.type === "CornerKicksSum",
            )?.value,
          }}
        />
      </Row>
      <Row>
        <Stat
          game={game}
          category={"Offsides"}
          stat={{
            home: game?.sportec_team_stats?.home?.find(
              (stat) => stat.type === "Offsides",
            )?.value,
            away: game?.sportec_team_stats?.away?.find(
              (stat) => stat.type === "Offsides",
            )?.value,
          }}
        />
      </Row>
      <Row>
        <Stat
          game={game}
          category={"Fouls"}
          stat={{
            home: game?.sportec_team_stats?.home?.find(
              (stat) => stat.type === "FoulsAgainstOpponent",
            )?.value,
            away: game?.sportec_team_stats?.away?.find(
              (stat) => stat.type === "FoulsAgainstOpponent",
            )?.value,
          }}
        />
      </Row>
      <Row>
        <Stat
          game={game}
          category={"Yellow Cards"}
          stat={{
            home:
              parseInt(
                game?.sportec_team_stats?.home?.find(
                  (stat) => stat.type === "CardsYellow",
                )?.value ?? 0,
              ) +
              parseInt(
                game?.sportec_team_stats?.home?.find(
                  (stat) => stat.type === "CardsYellowRed",
                )?.value ?? 0,
              ),
            away:
              parseInt(
                game?.sportec_team_stats?.away?.find(
                  (stat) => stat.type === "CardsYellow",
                )?.value ?? 0,
              ) +
              parseInt(
                game?.sportec_team_stats?.away?.find(
                  (stat) => stat.type === "CardsYellowRed",
                )?.value ?? 0,
              ),
          }}
        />
      </Row>
      <Row>
        <Stat
          game={game}
          category={"Red Cards"}
          stat={{
            home: game?.sportec_team_stats?.home?.find(
              (stat) => stat.type === "CardsRed",
            )?.value,
            away: game?.sportec_team_stats?.away?.find(
              (stat) => stat.type === "CardsRed",
            )?.value,
          }}
        />
      </Row>
      <Row>
        <Stat
          game={game}
          category={"Possession"}
          stat={{
            home: game?.sportec_team_stats?.home?.find(
              (stat) => stat.type === "PossessionPercentage",
            )?.value,
            away: game?.sportec_team_stats?.away?.find(
              (stat) => stat.type === "PossessionPercentage",
            )?.value,
          }}
        />
      </Row>
      <Row>
        <Stat
          game={game}
          category={"Passes Completed"}
          stat={{
            home: game?.sportec_team_stats?.home?.find(
              (stat) => stat.type === "PassesSuccessfulSum",
            )?.value,
            away: game?.sportec_team_stats?.away?.find(
              (stat) => stat.type === "PassesSuccessfulSum",
            )?.value,
          }}
        />
      </Row>
        <Row>
          <Stat
            game={game}
            category={"xG"}
            stat={{
              home: parseFloat(
                game?.sportec_team_stats?.home?.find(
                  (stat) => stat.type === "xG",
                )?.value,
              )?.toFixed(2),
              away: parseFloat(
                game?.sportec_team_stats?.away?.find(
                  (stat) => stat.type === "xG",
                )?.value,
              )?.toFixed(2),
            }}
          />
        </Row>
    </Main>
  );
}
